import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from './helper.service';
import { PopupMediaPlayerComponent } from '../components/popup-media-player/popup-media-player.component';
import { currentAppToken } from '../auth/app-token';

@Injectable({
  providedIn: 'root',
})
export class SignedUrlService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly helperService: HelperService,
    private readonly apiService: ApiService
  ) {}

  public getSubSectionFileImageSignedUrl(s: any, l: any): void {
    s.img = l.signedURL;
    if (!s.img) s.img = this.helperService.getAvatarNoImage();
  }

  public playerSignedUrl(file: any, windowClass?: any): void {
    const modalRef = this.modalService.open(PopupMediaPlayerComponent, { size: 'lg', windowClass: windowClass });
    modalRef.componentInstance.file = file;
  }

  public downloadSignedUrl(
    file: any,
    opts: any,
    onloadstart?: any,
    onprogress?: any,
    onloadend?: any,
    onerror?: any
  ): void {
    const token = currentAppToken();
    download(file.signedURL, file.name, opts, onloadstart, onprogress, onloadend, onerror, [
      { name: 'Authorization', value: 'Bearer ' + token },
      { name: 'X-Download', value: 'true' },
    ]);
  }

  getObjectStorageInfo(fileId: string) {
    return this.apiService.httpGet(`/api/signed-url/${fileId}`);
  }
}
